import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, PublicClientApplication } from '@azure/msal-browser';

import { BrowserService } from '../services/browser.service';

const env = '__env';

const isIe = BrowserService.isIE();
const msalApplicationScope = [`${window[env]?.adClientId}/.default`];
const msalPermissions = ['email', 'openid', 'profile'];
export const msalProtectedResourceMap = new Map()
    .set('https://graph.microsoft.com/v1.0/me/photos', ['user.read'])
    .set('/api/web/action-entries-en.json', null)
    .set('/api/', [...msalApplicationScope]);

export const msalUnprotectedResources = ['/assets/', '/api/web/'];

export const msalFactory = () => new PublicClientApplication({ // MSAL Configuration
  auth: {
    clientId: window[env]?.adClientId,
    authority: 'https://login.microsoftonline.com/' + window[env]?.tenantId,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true
  },
  cache: {
      cacheLocation : BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIe ? true : false, // set to true for IE 11
  },
  system: {
      loggerOptions: {
          loggerCallback: () => {},
          piiLoggingEnabled: false
      }
  },
});

export const msalGuardConfig: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect, // MSAL Guard Configuration
  authRequest: {
    scopes: [...msalApplicationScope, ...msalPermissions],
    prompt: 'select_account',
  },
  loginFailedRoute: '/',
};

export const msalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
  protectedResourceMap: msalProtectedResourceMap,
};
